import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-up-and-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.83121 8.90139L12.2236 16.5093L8.93781 17.543C8.59165 17.6519 8.34809 17.9625 8.32484 18.3246L8.26197 19.3037L14.1181 21.7232C14.6223 21.9315 15.1948 21.8938 15.6673 21.621L21.8035 18.0782C22.4585 17.7001 22.7979 16.9452 22.6461 16.2043L21.5145 10.6794C21.3477 9.8651 20.633 9.27914 19.8018 9.27519L15.6049 9.25528C15.2937 9.25381 14.9877 9.33502 14.7182 9.49062L12.849 10.5698L10.8721 7.14571C10.3873 6.30598 9.31356 6.01827 8.47383 6.50309C7.63411 6.9879 7.3464 8.06166 7.83121 8.90139Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.83121 8.90139L12.2236 16.5093L8.93781 17.543C8.59165 17.6519 8.34809 17.9625 8.32484 18.3246L8.26197 19.3037L14.1181 21.7232C14.6223 21.9315 15.1948 21.8938 15.6673 21.621L21.8035 18.0782C22.4585 17.7001 22.7979 16.9452 22.6461 16.2043L21.5145 10.6794C21.3477 9.8651 20.633 9.27914 19.8018 9.27519L15.6049 9.25528C15.2937 9.25381 14.9877 9.33502 14.7182 9.49062L12.849 10.5698L10.8721 7.14571C10.3873 6.30598 9.31356 6.01827 8.47383 6.50309C7.63411 6.9879 7.3464 8.06166 7.83121 8.90139Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.19787 4.50052V1.51524L1.4982 1.51318M5.19787 15.5005L5.19787 18.4858L1.49799 18.4863M4.01024 17.95C-0.0185398 13.4026 -0.00335695 6.52984 4.05579 1.99996","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureUpAndDown = Vue.extend<IconProps>({
  name: 'GestureUpAndDownIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-up-and-down',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureUpAndDown;
